<template>
  <v-bottom-navigation
    :value="pageIndex"
    color="light-green darken-2"    
    grow
    style="position:absolute,bottom:0"
    >
    <v-btn
      height="100%"
      @click="$emit('index-change',0,'map','mdi-plus')"
    >
      <span>Map</span>
      <v-icon>mdi-map</v-icon>
    </v-btn>
    <v-divider vertical>      
    </v-divider>
    <v-btn
    height="100%"
    @click="$emit('index-change',1,'profile','mdi-pencil')"
    >
      <span>Profile</span>
      <v-icon>mdi-account</v-icon>
    </v-btn>
    <v-divider vertical>      
    </v-divider>
    <v-btn
      height="100%"
      @click="$emit('index-change',2,'coupons','mdi-autorenew')"      
    >
      <span>Coupons</span>
      <v-icon>mdi-tag</v-icon>
    </v-btn>
    <v-divider vertical>      
    </v-divider>
    <v-btn
      height="100%"
      @click="$emit('index-change',3,'forum','none')"
    >
      <span>Forum</span>
      <v-icon>mdi-forum</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
    name:'Footer',
    props:['pageIndex'],        
}
</script>

<style>

</style>